import { useEffect, useRef, useState } from 'react';
import { useCallbackRef } from '../../hooks/useCallbackRef';
import classes from './styles.module.css';

function useCountdownSeconds({
	initialSeconds,
	secondsElement,
}: {
	initialSeconds: number;
	secondsElement: React.MutableRefObject<HTMLSpanElement>;
}) {
	const [seconds, setSeconds] = useState(initialSeconds);
	const timeintervalRef = useRef<NodeJS.Timeout | null>(null);
	const updateClock = useCallbackRef(() => {
		if (seconds <= 0) {
			clearInterval(timeintervalRef.current);

			return;
		}

		setSeconds((prev) => prev - 1);
	});
	const startCountdown = useCallbackRef(() => {
		timeintervalRef.current = setInterval(updateClock, 1000);
	});

	useEffect(() => {
		if (!secondsElement.current) {
			return;
		}

		const spanElm = document.createElement('span');

		spanElm.classList.add(classes.secondsAmount);
		spanElm.innerHTML = ('0' + seconds).slice(-2);

		if (seconds > 0) {
			spanElm.classList.add(classes.secondsAmount_animated);
		}

		if (seconds <= 0) {
			spanElm.classList.add(classes.secondsAmount_animatedHalf);
		}

		spanElm.addEventListener('animationend', () => {
			const parsedInt = parseInt(spanElm.innerHTML);

			if (parsedInt <= 1) {
				return;
			}

			// spanElm.remove();
		});
		// }

		secondsElement.current.append(spanElm);
	}, [seconds, secondsElement]);

	return {
		startCountdown,
		seconds,
	};
}

export { useCountdownSeconds };
